// src/components/QuickAddModal.jsx
import React, { useEffect, useRef } from "react";
import QuickAddTable from "../CreateTaskModal/QuickAddTable"
import "../CreateTaskModal/CreateTaskModal.scss"; // reuse existing modal styles if you have
import "./QuickAddModal.scss"

export default function QuickAddModal({ open, onClose, context, onCreated }) {
  const tableRef = useRef(null);

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "");
  }, [open]);

  if (!open) return null;

  const handleSaveAllAndClose = async () => {
    try {
      if (tableRef.current?.flushAll) {
        await tableRef.current.flushAll();
      }
      // close modal after successful flushAll
      if (typeof onClose === "function") onClose();
    } catch (err) {
      // keep modal open so user can fix errors
      console.error("Save All failed:", err);
      // optionally show toast here
    }
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal-window" style={{ maxWidth: 840 }}>
        <header className="modal-header">
          <h3>Quick Add Tasks</h3>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn secondary" onClick={handleSaveAllAndClose}>Save All & Close</button>
            <button aria-label="Close" onClick={onClose}>✕</button>
          </div>
        </header>
        <main className="modal-body">
          <QuickAddTable ref={tableRef} context={context} onCreated={onCreated} />
        </main>
      </div>
    </div>
  );
}